import { AfterViewInit, Component, EventEmitter, Inject, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';

import { MotesLoginService } from '../../motes-login';
import { ContainerType, Media } from '../../models';
import { UploadCropperComponent } from '../../components/upload-cropper/upload-cropper.component';

export enum EditorTabId {
    'tags',
    'media'
}

@Component({
    selector: 'cms-editor',
    templateUrl: './cms-editor.component.html',
    styleUrls: ['./cms-editor.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CmsEditorComponent implements AfterViewInit {
    @Input() editMode = false;
    @Input() showSave = true;
    @Input() showAdd = true;
    @Input() showDelete = true;
    @Input() activeTab: EditorTabId = EditorTabId.tags;
    @Input() postKey: string;

    @Input() showMediaUpload = false;
    @Input() frontImage: Media;
    @Input() mediaList: Media[];
    @Input() locale : string;

    @Output() activeTabChange = new EventEmitter<EditorTabId>();
    @Output() editModeChange = new EventEmitter<boolean>();
    @Output() saveEntry = new EventEmitter<void>();
    @Output() addEntry = new EventEmitter<void>();
    @Output() deleteEntry = new EventEmitter<void>();
    @Output() superAdminRights = new EventEmitter<boolean>();

    @Output() frontImageUploaded = new EventEmitter<Media>();
    @Output() contentMediaUploaded = new EventEmitter<Media>();
    @Output() uploadCropperInit = new EventEmitter<UploadCropperComponent>();

    @ViewChild('uploadCropper') uploadCropper: UploadCropperComponent;

    public isSuperAdmin: boolean = false;
    public isCropperShown: boolean = false;

    // Export to view
    public EditorTabId = EditorTabId;
    public ContainerType = ContainerType;

    constructor(private loginService: MotesLoginService) {
        this.loginService.watchUserRights().subscribe((userRights) => {
            this.isSuperAdmin = userRights && userRights.isSuperAdmin;
            this.superAdminRights.emit(this.isSuperAdmin);
        });
    }

    ngAfterViewInit() {
        // Expose upload cropper to the world
        this.uploadCropperInit.emit(this.uploadCropper);
    }

    public toggleEditMode() {
        this.editMode = !this.editMode;
        this.editModeChange.emit(this.editMode);
    }

    public openActiveTab(tabId: EditorTabId) {
        this.activeTab = tabId;
        this.activeTabChange.emit(tabId);
    }

    public showCropper(show: boolean) {
        this.isCropperShown = show;
    }

    public save() {
        this.saveEntry.emit();
    }

    public add() {
        this.addEntry.emit();
    }

    public delete() {
        this.deleteEntry.emit();
    }

    public onFrontImageUploadDone(media: Media) {
        this.frontImageUploaded.emit(media);
    }

    public onContentImageUploadDone(media: Media) {
        this.contentMediaUploaded.emit(media);
    }
}
